import { ConfirmDialog } from "@/components/ui/confirm-dialog";

function ActivateDeactivateUserDialog({ open, onOpenChange, action, userLabel, onConfirm, loading }) {
    const isDeactivate = action === 'Deactivate';

    const handleOpenChange = (nextOpen) => {
        if (!loading) {
            onOpenChange(nextOpen);
        }
    };

    return (
        <ConfirmDialog
            open={open}
            onOpenChange={handleOpenChange}
            title={isDeactivate ? 'Deactivate User' : 'Reactivate User'}
            description={
                isDeactivate
                    ? `Are you sure you want to deactivate ${userLabel}?`
                    : `Are you sure you want to reactivate ${userLabel}?`
            }
            onConfirm={onConfirm}
            onCancel={() => handleOpenChange(false)}
            confirmText="Yes"
            cancelText="No"
            variant="warning"
            confirmVariant="secondary"
            loading={loading}
            showIcon={true}
        />
    );
}

export default ActivateDeactivateUserDialog;
